import moment from "moment";

const useExpedicaoExport = () => {
  const handleExportList = (data) => {
    const csvContent = "SKU,Nome do Produto,Quantidade Total,Total de Etiquetas\n" +
      data.map(item => 
        `${item.sku},"${item.item_name}",${item.total_quantity},${item.invoice_count}`
      ).join("\n");
    
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("hidden", "");
    link.setAttribute("href", url);
    link.setAttribute("download", `lista_separacao_${moment().format("DD-MM-YYYY")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handlePrintList = (data) => {
    const printContent = `
      <html>
        <head>
          <title>Lista de Separação - ${moment().format("DD/MM/YYYY")}</title>
          <style>
            body { 
              font-family: 'Arial', sans-serif; 
              margin: 20px; 
              color: #333;
              line-height: 1.6;
            }
            .header { 
              border-bottom: 2px solid #6b7280; 
              padding-bottom: 15px; 
              margin-bottom: 20px; 
            }
            h1 { 
              color: #374151; 
              margin: 0;
              font-size: 24px;
            }
            .date { 
              color: #6b7280; 
              font-size: 14px; 
              margin-top: 5px;
            }
            .item { 
              margin: 8px 0; 
              padding: 12px; 
              border-left: 4px solid #e5e7eb;
              background: #f9fafb;
              border-radius: 4px;
            }
            .sku { font-weight: bold; font-family: monospace; }
            .quantidade { 
              background: #e5e7eb; 
              padding: 2px 8px; 
              border-radius: 12px; 
              font-size: 12px; 
              font-weight: bold;
            }
            .status {
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 12px;
              font-weight: bold;
              text-transform: capitalize;
            }
            .status.pendente { background: #fecaca; color: #991b1b; }
            .status.separado { background: #fed7aa; color: #9a3412; }
            .status.expedido { background: #bbf7d0; color: #14532d; }
            .summary {
              margin-top: 20px;
              padding: 15px;
              background: #f3f4f6;
              border-radius: 8px;
              border: 1px solid #d1d5db;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Lista de Separação</h1>
            <div class="date">Gerada em: ${moment().format("DD/MM/YYYY [às] HH:mm")}</div>
          </div>
          
          ${data.map(item => `
            <div class="item">
              <div>
                <span class="sku">SKU: ${item.sku}</span> | 
                <strong>Produto:</strong> ${item.item_name}
              </div>
              <div style="margin-top: 8px;">
                <span class="quantidade">Qtd: ${item.total_quantity}</span>
                <span class="notas" style="margin-left: 10px;">Etiquetas: ${item.invoice_count}</span>
              </div>
            </div>
          `).join("")}
          
          <div class="summary">
            <strong>Resumo:</strong> ${data.length} itens | 
            Total: ${data.reduce((sum, item) => sum + item.total_quantity, 0)} unidades |
            Etiquetas: ${data.reduce((sum, item) => sum + item.invoice_count, 0)} etiquetas de transporte
          </div>
        </body>
      </html>
    `;
    
    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return {
    handleExportList,
    handlePrintList
  };
};

export default useExpedicaoExport;